'use client';

import Image from '@/components/Image';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useTranslations } from '@/i18n/use-translations';

const LensProcessNav = ({ isDarkMode = false }: { isDarkMode?: boolean }) => {
  const t = useTranslations('layout.LensProcessNav');
  // 移动端文案（较短）
  const mobileList = [
    {
      img: '/layout/lens_1.png',
      title: t('title1'),
      desc: t('desc1'),
    },
    {
      img: '/layout/lens_2.png',
      title: t('title2'),
      desc: t('desc2'),
    },
    {
      img: '/layout/lens_3.png',
      title: t('title3'),
      desc: t('desc3'),
    },
    {
      img: '/layout/lens_4.png',
      title: t('title4'),
      desc: t('desc4'),
    },
  ];

  // PC端文案（较长）
  const desktopList = [
    {
      img: '/layout/lens_1.png',
      title: t('title1'),
      desc: t('fullDesc1'),
    },
    {
      img: '/layout/lens_2.png',
      title: t('title2'),
      desc: t('fullDesc2'),
    },
    {
      img: '/layout/lens_3.png',
      title: t('title3'),
      desc: t('fullDesc3'),
    },
    {
      img: '/layout/lens_4.png',
      title: t('title4'),
      desc: t('fullDesc4'),
    },
  ];

  return (
    <>
      {/* 移动端版本 */}
      <WapOnly>
        <div
          className={`py-[16px] px-[28px] pb-[32px] ${isDarkMode ? 'bg-[#131415] text-[#ffffff]' : 'bg-[#fafafa] text-[#282828]'}`}
        >
          <b className="text-[14px] font-bb"> {t('configureYourGlasses')} </b>
          <ul className="relative mt-[20px]">
            {mobileList.map((item, index) => (
              <li
                key={item.title}
                className={`flex items-center ${index < mobileList.length - 1 ? 'mb-[20px]' : ''}`}
              >
                <Image
                  src={item.img}
                  alt={item.title}
                  className="w-[32px] h-[32px] mr-[12px] relative z-[1]"
                  width={32}
                  height={32}
                />
                <div className="flex-1">
                  <b className="text-[14px]">{item.title}</b>
                  <p className="text-[12px] leading-[18px] text-[#a9a9a9]">{item.desc}</p>
                </div>
              </li>
            ))}
            {/* 移动端连接线 */}
            <div className="absolute left-[16px] top-[16px] bottom-[16px] border-l border-dashed border-[#a9a9a9]" />
          </ul>
        </div>
      </WapOnly>

      {/* PC端版本 */}
      <WebOnly>
        <div
          className={`lg:py-[30px] lg:px-[24px] md:py-[15px] md:px-[12px] min-w-[334px] h-full max-w-[428px] ${isDarkMode ? 'bg-[#131415] text-[#ffffff]' : 'bg-[#f4f4f4] text-[#282828]]'}`}
        >
          <b className="block font-bb md:text-[14px] lg:text-[18px] leading-[22px] mb-[20px]">
            {t('configureYourGlasses').toUpperCase()}
          </b>
          <ul className="relative">
            {desktopList.map((item, index) => (
              <li
                key={item.title}
                className={`flex items-start ${index < desktopList.length - 1 ? 'mb-[20px]' : ''}`}
              >
                <Image
                  src={item.img}
                  alt={item.title}
                  className="w-[32px] h-[32px] mr-[12px] relative z-[1]"
                  width={32}
                  height={32}
                />
                <div className="flex-1">
                  <b className="text-[14px] font-bb leading-[17px]">{item.title}</b>
                  <p className="text-[12px] leading-[18px] text-[#a9a9a9] mt-[6px]">{item.desc}</p>
                </div>
              </li>
            ))}
            {/* PC端连接线 */}
            <div className="absolute left-[16px] top-[16px] bottom-[36px] border-l border-dashed border-[#a9a9a9]" />
          </ul>
        </div>
      </WebOnly>
    </>
  );
};

export default LensProcessNav;
